export const orderProcessSteps = [
  "En quelques clics, choisissez votre panier Kooli et ses options",
  "Renseignez les informations nécessaires à la livraison",
  "Vous effectuez le paiement en ligne de façon sécurisée",
  "Nous nous occupons de livrer le panier à l'adresse indiquée",
];

export { orderSteps } from "./orderSteps";
export { products } from "./products";
